module.exports = __webpack_public_path__ + "img/pool-splash.613b8564.jpg";